import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import PullToRefresh from './PullToRefresh';

/**
 * Shell for the signed-out account pages (login, forgotten password, reset):
 * logo header, a centred card with a title, footer.
 */
function AuthPageShell({ title, children }) {
  const handleRefresh = useCallback(async () => {
    window.location.reload();
  }, []);

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-light dark:bg-background-dark">
        <header className="sticky top-0 z-50 w-full border-b border-gray-200/50 dark:border-gray-800/50 bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-sm">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 items-center justify-between">
              <Link to="/" className="flex items-center gap-4">
                <img src="/favicon-32x32.png" alt="Dissona" className="size-6" />
                <h2 className="text-xl font-bold text-gray-900 dark:text-white">Dissona</h2>
              </Link>
            </div>
          </div>
        </header>

        <div className="flex-grow flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-md">
            <div className="bg-white dark:bg-background-dark/50 border border-gray-200 dark:border-gray-800 rounded-lg p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-8">
                {title}
              </h2>
              {children}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </PullToRefresh>
  );
}

export default AuthPageShell;
